import { Box,
    BoxProps, 
    Button, 
    ButtonProps, 
    Card, 
    CardProps, 
    FormControl, 
    FormControlProps, 
    Grid, 
    InputLabel, 
    MenuItem, 
    Select, 
    SelectProps, 
    TextField, 
    TextFieldProps, 
    Typography, 
    TypographyProps, 
    useTheme 
} from "@mui/material"
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import React from "react"
import { useTranslation } from "react-i18next";
import * as applicationService from "services/application-service";
import * as certificateService from 'services/certificate-service';
import * as Styles from "pages/employee/export/listExports/listExports.styles";
import 'dayjs/locale/nl';
import 'dayjs/locale/fr';
import 'dayjs/locale/en';

const ListExports = () => {
    const { t, i18n: { language } } = useTranslation();
    const theme = useTheme();

    const [dateFrom, setDateFrom] = React.useState<Date|undefined|null>(null);
    const [dateTo, setDateTo] = React.useState<Date|undefined|null>(null);
    const [createFrom, setCreateFrom] = React.useState<Date|undefined|null>(null);
    const [createTo, setCreateTo] = React.useState<Date|undefined|null>(null);
    const [errorMessage, setErrorMessage] = React.useState<string>('');
    const [format, setFormat] = React.useState<'requests' | 'certificates' | ''>('');
    const [extension, setExtension] = React.useState<'csv' | 'xlsx' | ''>('');

    const handleChangeFormat = (event: any) => {
        setFormat(event.target.value);
    }

    const handleChangeExtension = (event: any) => {
        setExtension(event.target.value);
    }

    const handleExportCsv = async () => {
        console.log(dateTo, dateFrom, createFrom, createTo)
        console.log(format)
        if (dateTo !== null && dateFrom === null) {
            setErrorMessage(t('exports.errors.validation'));
            return;
        } else if (dateTo === null && dateFrom !== null) {
            setErrorMessage(t('exports.errors.validation'));
            return;
        }
        if (createFrom !== null && createTo === null) {
            setErrorMessage(t('exports.errors.creation'));
            return;
        } else if (createFrom === null && createTo !== null) {
            setErrorMessage(t('exports.errors.creation'));
            return;
        } else if (dateTo === null && dateFrom === null && createFrom === null && createTo === null) {
            setErrorMessage(t('exports.datesError'))
            return;
        }
        if (((dateTo !== undefined && dateTo !== null) ||
            (dateFrom !== null && dateFrom !== undefined) ||
            (createFrom !== null && createFrom !== undefined) ||
            (createTo !== null && createTo !== undefined)) &&
            format !== '' && extension !== '') {
            if (format === 'requests') {
                applicationService.exportDataAsCsv(dateTo, dateFrom, createFrom, createTo, extension).then((res: Blob) => {
                    if (res !== undefined) {
                        var fileName = `${t("exports.export")}_${t("manage.requestsTitle")}`;
                        downloadFile(res, fileName);
                    }
                });
            } else if (format === 'certificates') {
                certificateService.exportDataAsCsv(dayjs(dateTo), dayjs(dateFrom), dayjs(createFrom), dayjs(createTo), extension).then((res: Blob) => {
                    if (res !== undefined) {
                        var fileName = `${t("exports.export")}_${t("manage.certificateTitle")}`;
                        downloadFile(res, fileName);
                    }
                });
            }
            setErrorMessage('')
        } else if (format === '') {
            setErrorMessage(t('exports.errors.format'))
        } else if (extension === '') {
            setErrorMessage(t('exports.errors.extension'))
        } else {
            setErrorMessage(t('exports.datesError'))
        }
    }

    const downloadFile = (blob: Blob, fileName: string) => {
        var fileUrl = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = fileUrl;
        var fileExntension = blob.type.split('/')[1];

        //Convert the extension to the correct format
        if (fileExntension === 'vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
            fileExntension = 'xlsx';
        }
        else {
            fileExntension = 'csv';
        }
        
        var now = dayjs().format('DD-MM-YYYY').toString()
        link.download = `${fileName}_${now}.${fileExntension}`;
        link.click();
    }

    const listRequestsWrapperProps: CardProps = {
        sx: Styles.listRequestsWrapper(theme)
    }

    const listRequestsTitleProps: TypographyProps = {
        variant: "h4",
        sx: Styles.listRequestsTitle(theme)
    }

    const titleWrapperProps: BoxProps = {
        sx: Styles.titleWrapper(theme)
    }

    const buttonProps: ButtonProps = {
        sx: Styles.button(theme),
        variant: "contained",
        onClick: handleExportCsv,
        disabled: /*(*/format === '' || extension === '' /*||*/ 
            // ((dateTo === null || dateTo === undefined || dateFrom === null || dateFrom === undefined) && (createFrom === null || createFrom === undefined || createTo === null || createTo === undefined)))
    }

    const tableTextFieldProps: TextFieldProps = {
        sx: Styles.tableTextField(theme)
    }

    const dateTextFieldProps: TextFieldProps = {
        sx: Styles.dateTextField(theme)
    }

    const dataFieldProps: BoxProps = {
        sx: Styles.dataField(theme)
    }

    const locationBoxProps: BoxProps = {
        sx: Styles.locationBox(theme)
    }

    const errorBoxProps: BoxProps = {
        sx: Styles.errorBox(theme)
    }

    const formProps: FormControlProps = {
        sx: Styles.form(theme),
    }
    
    const selectFormatProps: SelectProps = {
        labelId: 'select-type-label',
        label: t('exports.format'),
        value: format,
        onChange: handleChangeFormat,
    }

    const selectExtensionProps: SelectProps = {
        labelId: 'select-extension-label',
        label: t('exports.extension'),
        value: extension,
        onChange: handleChangeExtension,
    }

    const dateProps: any = {
        sx: Styles.datePicker(theme),
        renderInput: (params: any) => <TextField {...params} {...dateTextFieldProps}/>,
        inputFormat: "DD/MM/YYYY"
    }

    const handleDateChange = (value: Date | null | undefined, mode: "dateFrom" | "dateTo" | 'createFrom' | 'createTo'): void => {
        switch (mode) {
            case 'dateFrom':
                setDateFrom(value);
                break;
            case 'dateTo':
                setDateTo(value);
                break;
            case 'createFrom':
                setCreateFrom(value);
                break;
            case 'createTo':
                setCreateTo(value);
                break;
        }
    }

    return (
        <Card {...listRequestsWrapperProps}>

            <Box {...titleWrapperProps}>
                <Typography {...listRequestsTitleProps}>{t("exports.export")}</Typography>
            </Box>
            <Box {...dataFieldProps}>
               <Box {...locationBoxProps}>
                    <LocalizationProvider adapterLocale={language} dateAdapter={AdapterDayjs}>
                        <Grid container direction="row" sx={{justifyContent: 'center', alignItems: 'center'}}>
                        <FormControl  sx={{width: '250px', marginRight: '0.75rem'}}>
                            <DatePicker
                                label={t("exports.startDate")}
                                value={dateFrom}
                                onChange={(newValue: any, _) => {
                                    handleDateChange(newValue, 'dateFrom');
                                }}
                                {...dateProps}
                            />
                        </FormControl>
                        <Box>-</Box>
                        <FormControl  sx={{width: '250px', marginLeft: '0.75rem'}}>
                            <DatePicker
                                label={t("exports.endDate")}
                                value={dateTo}
                                onChange={(newValue: any, _: any) => {
                                    handleDateChange(newValue, 'dateTo');
                                }}
                                {...dateProps}
                            />
                        </FormControl>
                        </Grid>
                    </LocalizationProvider>
               </Box>
               <Box {...locationBoxProps}>
                    <LocalizationProvider adapterLocale={language} dateAdapter={AdapterDayjs}>
                        <Grid container direction="row" sx={{justifyContent: 'center', alignItems: 'center'}}>
                            <FormControl sx={{width: '250px', marginRight: '0.75rem'}}>
                            <DatePicker
                                label={t("exports.createStartDate")}
                                value={createFrom}
                                onChange={(newValue: any, _) => {
                                    handleDateChange(newValue, 'createFrom');
                                }}
                                {...dateProps}
                            />
                            </FormControl>
                            <Box>-</Box>
                            <FormControl sx={{width: '250px', marginLeft: '0.75rem'}}>
                                <DatePicker
                                    label={t("exports.createEndDate")}
                                    value={createTo}
                                    onChange={(newValue: any, _: any) => {
                                        handleDateChange(newValue, 'createTo');
                                    }}
                                    {...dateProps}
                                />
                            </FormControl>
                        </Grid>
                    </LocalizationProvider>
               </Box>
               <Box>
                <FormControl {...formProps} >
                    <InputLabel id="select-type-label">{t('exports.format')}</InputLabel>
                    <Select {...selectFormatProps} >
                        <MenuItem value={'requests'}>{t("manage.requestsTitle")}</MenuItem>
                        <MenuItem value={'certificates'}>{t("manage.certificateTitle")}</MenuItem>
                    </Select>
                </FormControl>
               </Box>
               <Box>
                <FormControl {...formProps} >
                    <InputLabel id="select-extension-label">{t('exports.extension')}</InputLabel>
                    <Select {...selectExtensionProps} >
                        <MenuItem value={'csv'}>{t("csv")}</MenuItem>
                        <MenuItem value={'xlsx'}>{t("xlsx")}</MenuItem>
                    </Select>
                </FormControl>
               </Box>
               <Button {...buttonProps}>{t("exports.export")}</Button>
               {errorMessage && 
                <Box {...errorBoxProps}>
                    {errorMessage}
                </Box>
               }
            </Box>
        </Card>
    )
}

export default ListExports;